import type { TExperienceMode, TRecordingMode } from "@lexicanon/shared"

/**
 * One dismissal per mode pair, in this browser. "full-lite" is a Full meeting
 * opened while new meetings default to Lite.
 */
export function modeBannerDismissKey(recordedAs: TRecordingMode, defaultForNew: TExperienceMode): string {
  return `lex:mode-banner-dismissed:${recordedAs}-${defaultForNew}`
}

export interface IKeyValueStore {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

export function isModeBannerDismissed(
  recordedAs: TRecordingMode,
  defaultForNew: TExperienceMode,
  store: IKeyValueStore,
): boolean {
  try {
    return store.getItem(modeBannerDismissKey(recordedAs, defaultForNew)) === "1"
  } catch {
    return false
  }
}

export function dismissModeBanner(
  recordedAs: TRecordingMode,
  defaultForNew: TExperienceMode,
  store: IKeyValueStore,
): void {
  try {
    store.setItem(modeBannerDismissKey(recordedAs, defaultForNew), "1")
  } catch {
    // Private mode and blocked storage throw. The banner can show again next time.
  }
}

/** localStorage, or a no-op store when the browser refuses access. */
export function browserBannerStore(): IKeyValueStore {
  try {
    return localStorage
  } catch {
    return {
      getItem: (): null => null,
      setItem: (): undefined => undefined,
    }
  }
}
